<!--
 * @Descripttion: 
 * @Author: luoyang
 * @Date: 2021-11-29 17:25:02
 * @LastEditors: luoyang
 * @LastEditTime: 2022-01-11 17:05:28
-->
<template>
  <!-- 应用成效 -->
  <div class="application_results-mb" ref="results">
    <div class="bganimation" ref="bganimation" :style="{background:'url('+applicationResults.bg+') no-repeat'}">
      <div class="mobile-container">
        <h1 class="partH1" ref="HeaderTitle">应用成效</h1>
        <ul class="application_results_ul-mb mb_feature_ul_bg" ref="ul">
          <li class="application_results_li-mb" :class="specialStyle?'application_results_li-mb-2':''" v-for="(item,index) in applicationResults.dataLi.part1" :key="index">
            <img :src="item.img">
            <p>{{item.title}}</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    applicationResults: {
      type: Object,
      default: () => {
        return {};
      },
    },
    specialStyle: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style lang="scss" scoped>
.application_results-mb {
  // background: #f9f9f9;
  .bganimation {
    padding-bottom: 455px; // 526-71
  }
  .partH1 {
    width: 1720px;
    height: 180px;
    line-height: 180px;
    font-size: 156px;
    font-weight: 600;
    padding: 284px 0 174px;
    box-sizing: content-box;
    color: #fff;
  }
  .application_results_ul-mb {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
  }
  .mb_feature_ul_bg {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    .application_results_li-mb {
      width: 853px;
      height: 782px;
      background: #ffffff;
      margin-bottom: 71px;
      // display: grid;
      // place-items: center;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      img {
        margin-top: 144px; //ui勘察为164px 但是icon本身有留白
        height: 290px; //ui勘察为250px 但是icon本身有留白
        width: auto;
      }
      p {
        font-size: 85px;
        font-weight: 600;
        color: #000000;
        margin-top: 160px; //ui勘察为190px 但是icon本身有留白
      }
      /* 第1、3、5个子元素 */
      &:nth-child(2n + 1) {
        margin-right: 71px;
      }
    }
    .application_results_li-mb-2 {
      p {
        line-height: 128px;
        width: 680px;
        margin-top: 70px; //ui勘察为100px 但是icon本身有留白
        text-align: center;
      }
    }
  }
}
</style>